import { render } from "./FpuiInputPhone.vue?vue&type=template&id=0b2bdab3&lang=pug"
import script from "./FpuiInputPhone.vue?vue&type=script&lang=js"
export * from "./FpuiInputPhone.vue?vue&type=script&lang=js"

import "./FpuiInputPhone.vue?vue&type=style&index=0&id=0b2bdab3&lang=less"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__